import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import keys from 'lodash/keys';
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import fromPairs from 'lodash/fromPairs';
import { useRouteData } from './useRouteData';
import { emitPageView } from 'store/userEnvironment/userEnvironmentActions';
import { getBookingChannel } from 'store/checkout/checkoutSelectors';

export const useDataLayerPageVariables = () => {
  const [emitted, setEmitted] = useState(false);
  const trackedKeys = useRef([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const bookingChannel = useSelector(getBookingChannel);
  const { ready, ...routeData } = useRouteData();

  /* Reset "emitted" when path changes */
  useEffect(() => {
    setEmitted(false);
  }, [location.pathname]);

  /* Keep track of what variables have been set on previous pages */
  useEffect(() => {
    trackedKeys.current = uniq([...trackedKeys.current, ...keys(routeData)]);
  }, [routeData]);

  useEffect(() => {
    if (ready && !emitted && bookingChannel) {
      const resetPayload = fromPairs(map(trackedKeys.current, (key) => [key, undefined]));
      const payload = { bookingChannel, ...resetPayload, ...routeData };
      dispatch(emitPageView(payload));
      setEmitted(true);
    }
  }, [emitted, dispatch, ready, routeData, bookingChannel]);
};
